import { priceListProjectService } from '../services'
import Vue from 'vue'

const state = {
  all: {
    loading: false,
    saving: false
  }
}

const actions = {
  getByProjectId ({commit}, id) {
    return priceListProjectService.getByProjectId(id)
      .then(priceList => {
        return priceList.result
      })
  },

  savePriceList ({ commit, dispatch }, priceList) {
    commit('startSave')
    return priceListProjectService.savePriceList(priceList)
      .then(priceList => {
        commit('endSave')
        commit('savePriceListSuccess', priceList.result)
        return priceList.result
      }).catch(error => {
        commit('endSave')
        commit('savePriceListFailure')
        return Promise.reject(error)
      })
  }
}

const mutations = {
  startSave (state) {
    state.all.saving = true
  },

  endSave (state) {
    setTimeout(() => {
      state.all.saving = false
    }, 200)
  },

  // Save
  savePriceListSuccess (state, updatedPriceList) {
    Vue.prototype.$toast('Prislista sparad', 'success')
  },

  savePriceListFailure () {
    Vue.prototype.$toast('Kunde inte spara prislista', 'error')
  }
}

export const priceListProject = {
  namespaced: true,
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/price-list-project.module.js